export default __webpack_public_path__ + "static/media/position.40320af1.svg";